<template>
  <v-layout justify-space-between column fill-height>
    <v-list class="pa-0 pl-2" justify-end>
      <v-list-item-group mandatory>
        <v-list-item class="px-2" v-if="this.$store.getters['user/user'].SAPEmpId != '0000'">
          <v-list-item-avatar>
            <v-tooltip right color="primary" :disabled="mini">
              <template slot="activator" slot-scope="{ on }">
                <v-img v-on="mini ? {} : on" @click="!mini && changeUserPic()" :src="$store.getters['user/profilePicture']" :key="pictureKey" />
              </template>
              <span>{{ $t("changePic") }}</span>
              <input v-on:change="handleFileUpload()" type="file" accept="image/png, image/jpeg, image/jpg" ref="file" id="userPicFile" style="display: none" />
            </v-tooltip>
          </v-list-item-avatar>

          <v-list-item-content class="pt-1 pb-1">
            <v-list-item-title>
              {{ $store.getters["user/user"].Name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $t($store.getters["user/user"].UserLocation) }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-btn icon @click.stop="$emit('closeNavigation')">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-list-item>

        <v-list-item v-if="canAccessTimeManagement && this.$store.getters['user/user'].SAPEmpId != '0000'" @click="changeRoute('MainMenu')" class="px-2">
          <v-tooltip right :disabled="!mini" color="primary">
            <template slot="activator" slot-scope="{ on }">
              <v-list-item-avatar v-on="on" class="mr-0">
                <v-icon>mdi-alarm</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ $t("timekeeping") }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <span>{{ $t("timekeeping") }}</span>
          </v-tooltip>
        </v-list-item>

        <v-list-item
          v-if="canAccessManualTimeManagement && this.$store.getters['user/user'].SAPEmpId != '0000'"
          @click="changeRoute('ManualTimekeeping')"
          class="px-2"
        >
          <v-tooltip right :disabled="!mini" color="primary">
            <template slot="activator" slot-scope="{ on }">
              <v-list-item-avatar v-on="on" class="mr-0">
                <v-icon>mdi-timer-edit-outline </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ $t("manualTimekeeping") }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <span>{{ $t("manualTimekeeping") }}</span>
          </v-tooltip>
        </v-list-item>

        <v-list-item v-if="canAccessPresenceList && this.$store.getters['user/user'].SAPEmpId != '0000'" class="px-2" @click="changeRoute('PresenceList')">
          <v-tooltip right :disabled="!mini" color="primary">
            <template slot="activator" slot-scope="{ on }">
              <v-list-item-avatar v-on="on" class="mr-0">
                <v-icon>mdi-account-box-multiple-outline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ $t("presencelist") }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <span>{{ $t("presencelist") }}</span>
          </v-tooltip>
        </v-list-item>

        <v-list-item v-if="this.$store.getters['user/user'].SAPEmpId != '0000'" class="px-2" @click="AbsenceDialogOpen()">
          <v-tooltip right :disabled="!mini" color="primary">
            <template slot="activator" slot-scope="{ on }">
              <v-list-item-avatar v-on="on" class="mr-0">
                <v-icon>mdi-calendar-multiselect</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ $t("absenceRequest") }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <span>{{ $t("absenceRequest") }}</span>
          </v-tooltip>
        </v-list-item>

        <v-list-item
          v-if="
            (canAccessAbsenceOverview && this.$store.getters['user/user'].SAPEmpId != '0000') ||
            (canAccessAbsenceOverviewTeam && this.$store.getters['user/user'].SAPEmpId != '0000')
          "
          class="px-2"
          @click="changeRoute('AbsenceOverview')"
        >
          <v-tooltip right :disabled="!mini" color="primary">
            <template slot="activator" slot-scope="{ on }">
              <v-list-item-avatar v-on="on" class="mr-0">
                <v-icon>mdi-calendar-text-outline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ $t("absenceOverview") }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <span>{{ $t("absenceOverview") }}</span>
          </v-tooltip>
        </v-list-item>

        <v-list-group append-icon="mdi-chevron-right" v-if="canAccessUserAdministration" active-class="navigationItemListColor--text" class="cobi-rt-dn">
          <template v-slot:activator>
            <v-tooltip right color="primary" :disabled="!mini">
              <template v-slot:activator="{ on }">
                <v-list-item-avatar v-on="on" :class="['mr-0', mini ? '' : 'ml-n2']">
                  <v-icon size="24">mdi-domain</v-icon>
                </v-list-item-avatar>
              </template>
              <span>{{ $t("administration") }}</span>
            </v-tooltip>
            <v-list-item-content>
              <v-list-item-title class="body-2">{{ $t("administration") }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-if="canAccessUserAdministration || this.$store.getters['user/user'].SAPEmpId == '0000'"
            @click="changeRoute('Administration')"
            class="pl-8"
            active-class="navigationItemListColor--text"
            link
          >
            <v-list-item-avatar class="mr-0">
              <v-icon>mdi-calendar-clock</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="body-2">{{ $t("timeModels") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="canAccessUserAdministration"
            class="pl-8"
            @click="changeRoute('UserAdministration')"
            link
            active-class="navigationItemListColor--text"
          >
            <v-list-item-avatar class="mr-0">
              <v-icon>mdi-account-supervisor</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="body-2">{{ $t("userAdministration") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="canAccessUserAdministration" class="pl-8" @click="changeRoute('UserGroup')" link active-class="navigationItemListColor--text">
            <v-list-item-avatar class="mr-0">
              <v-icon>mdi-account-key</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="body-2">{{ $t("userRights") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group append-icon="mdi-chevron-right" v-if="canAccessManagement" active-class="navigationItemListColor--text" class="cobi-rt-dn">
          <template v-slot:activator>
            <v-tooltip right color="primary" :disabled="!mini">
              <template v-slot:activator="{ on }">
                <v-list-item-avatar v-on="on" :class="['mr-0', mini ? '' : 'ml-n2']">
                  <v-icon size="24">mdi-account-group</v-icon>
                </v-list-item-avatar>
              </template>
              <span>{{ $t("management") }}</span>
            </v-tooltip>

            <v-list-item-content>
              <v-list-item-title class="body-2">{{ $t("management") }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-if="canAccessManagement && $store.getters['server/stageProjectsAllowed'] == 1"
            class="pl-8"
            @click="changeRoute('ProjectManagement')"
            link
            active-class="navigationItemListColor--text"
          >
            <v-list-item-avatar class="mr-0">
              <v-icon>mdi-account-details</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="body-2">{{ $t("projectManagement") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="canAccessManagement && $store.getters['server/serviceCallsAllowed'] == 1"
            class="pl-8"
            @click="changeRoute('ServiceCallManagement')"
            link
            active-class="navigationItemListColor--text"
          >
            <v-list-item-avatar class="mr-0">
              <v-icon>mdi-layers-edit</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="body-2">{{ $t("serviceCalls") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group
          append-icon="mdi-chevron-right"
          v-if="canAccessGeneralReporting || canAccessGeneralReportingTeam"
          active-class="navigationItemListColor--text"
          class="cobi-rt-dn"
        >
          <template v-slot:activator>
            <v-tooltip right color="primary" :disabled="!mini">
              <template v-slot:activator="{ on }">
                <v-list-item-avatar v-on="on" :class="['mr-0', mini ? '' : 'ml-n2']">
                  <v-icon size="24">mdi-chart-timeline</v-icon>
                </v-list-item-avatar>
              </template>
              <span>{{ $t("generalReporting") }}</span>
            </v-tooltip>

            <v-list-item-content>
              <v-list-item-title class="body-2">{{ $t("generalReporting") }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-if="canAccessGeneralReporting || canAccessGeneralReportingTeam"
            class="pl-8"
            @click="changeRoute('TimeReport')"
            link
            active-class="navigationItemListColor--text"
          >
            <v-list-item-avatar class="mr-0">
              <v-icon>mdi-timeline-clock-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="body-2">{{ $t("worktime") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="canAccessGeneralReporting || canAccessGeneralReportingTeam"
            class="pl-8"
            @click="changeRoute('AbsenceReport')"
            link
            active-class="navigationItemListColor--text"
          >
            <v-list-item-avatar class="mr-0">
              <v-icon>mdi-badge-account-alert-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="body-2">{{ $t("absence") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="canAccessGeneralReporting || canAccessGeneralReportingTeam"
            class="pl-8"
            @click="changeRoute('TimeReports')"
            active-class="navigationItemListColor--text"
            link
          >
            <v-list-item-avatar class="mr-0">
              <v-icon>mdi-file-chart</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="body-2">{{ $t("timeReport") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="canAccessGeneralReporting || canAccessGeneralReportingTeam"
            class="pl-8"
            @click="changeRoute('Statistics')"
            link
            active-class="navigationItemListColor--text"
          >
            <v-list-item-avatar class="mr-0">
              <v-icon>mdi-chart-box-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="body-2">{{ $t("statistics") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item v-if="canAccessUserAdministration || this.$store.getters['user/user'].SAPEmpId == '0000'" class="px-2" @click="changeRoute('Settings')">
          <v-tooltip right color="primary" :disabled="!mini">
            <template v-slot:activator="{ on }">
              <v-list-item-avatar v-on="on" class="mr-0">
                <v-icon>mdi-cog-outline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content v-on="on">
                <v-list-item-title class="body-2">{{ $t("settings") }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <span>{{ $t("settings") }}</span>
          </v-tooltip>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-spacer />

    <v-list justify-end class="pb-0 pl-2">
      <v-divider style="border-width: 1px" />
      <v-list-item class="px-0" @click="logout()">
        <v-tooltip right :disabled="!mini" color="primary">
          <template v-slot:activator="{ on }">
            <v-list-item-avatar v-on="on" class="mr-0">
              <v-icon>mdi-logout-variant</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="body-2">{{ $t("logout") }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <span>{{ $t("logout") }}</span>
        </v-tooltip>
      </v-list-item>
    </v-list>

    <AbsenceDialog v-if="ShowAbsenceDialog" @close="ShowAbsenceDialog = false" :CanSendAbsence="false" :User="$store.getters['user/user']" />
  </v-layout>
</template>

<script>
import imageCompression from "browser-image-compression";

export default {
  name: "Navigation",
  components: {
    AbsenceDialog: () => import("./absenceDialog")
  },
  data() {
    return {
      leaveTime: null,
      updateRunning: false,
      pictureKey: 0,
      ShowAbsenceDialog: false,
      adminOpen: false,
      managementOpen: false,
      reportingOpen: false
    };
  },
  props: {
    mini: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.$root.$on("getStatus", async (executeImmediately) => {
      this.progressValue = await this.getStatus(executeImmediately);
    });
  },
  beforeDestroy() {
    this.$root.$off("getStatus", this.fn);
  },
  computed: {
    canAccessUserAdministration() {
      return this.$store.getters["user/user"].userGroupRights.canAccessUserAdministration;
    },
    canAccessPresenceList() {
      return (
        this.$store.getters["user/user"].userGroupRights.canAccessPresenceList || this.$store.getters["user/user"].userGroupRights.canAccessAdminPresenceList
      );
    },
    canAccessTimeManagement() {
      return this.$store.getters["user/user"].userGroupRights.canAccessTimeManagement;
    },
    canAccessManualTimeManagement() {
      return this.$store.getters["user/user"].userGroupRights.canAccessManualTimeManagement;
    },
    canAccessManagement() {
      return this.$store.getters["user/user"].userGroupRights.canAccessManagement;
    },
    canAccessAbsenceOverview() {
      return this.$store.getters["user/user"].userGroupRights.canAccessAbsenceOverview;
    },
    canAccessAbsenceOverviewTeam() {
      return this.$store.getters["user/user"].userGroupRights.canAccessAbsenceOverviewTeam;
    },
    canAccessGeneralReporting() {
      return this.$store.getters["user/user"].userGroupRights.canAccessGeneralReporting;
    },
    canAccessGeneralReportingTeam() {
      return this.$store.getters["user/user"].userGroupRights.canAccessGeneralReportingTeam;
    }
  },
  methods: {
    async logout() {
      let result = await this.showMessage(this.$t("logoutWarning"));
      if (result) {
        this.$store.dispatch("user/logout").then(() => {
          this.$router.push("/Login");
        });
      }
    },
    async showMessage(message) {
      return await this.$dialog
        .confirm(message)
        .then(() => {
          return true;
        })
        .catch(function () {
          return false;
        });
    },
    async updateData() {
      this.updateRunning = true;
      await this.getStatus(false);
      this.updateRunning = false;
    },
    async getStatus(executeImmediately) {
      await this.$store
        .dispatch("user/getStatus", {
          timeStamp: this.$moment(),
          executeImmediately: executeImmediately
        })
        .then(async () => {
          this.$root.$emit("statusRefresh");
        })
        .catch((err) => {
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", err.response.data, "bottom", "right");
          }
        });
    },
    changeUserPic() {
      document.getElementById("userPicFile").click();
    },
    async handleFileUpload() {
      this.file = this.$refs.file.files[0];
      var realFile = this.$refs.file.files[0];
      let fr = new FileReader();
      const vm = this;
      fr.addEventListener(
        "load",
        async function () {
          vm.defaultPic = fr.result;

          const imageFile = await imageCompression.getFilefromDataUrl(fr.result, "profilePicture", 0);
          let compressedFile = null;

          const options = {
            maxSizeMB: 0.1,
            maxWidthOrHeight: 1920,
            useWebWorker: true
          };
          try {
            compressedFile = await imageCompression(imageFile, options);
          } catch (error) {
            console.log(error);
          }

          if (compressedFile != null) {
            await vm.uploadProfilePicture(await imageCompression.getDataUrlFromFile(compressedFile));
          } else await vm.uploadProfilePicture(fr.result);
        },
        false
      );
      if (this.file) {
        fr.readAsDataURL(realFile);
      } else {
        Helper.showAlert(app, this.$t("noPictureUploaded") + "!", "error");
      }
    },
    async uploadProfilePicture(profilePicture) {
      await this.$store
        .dispatch("user/updateProfilePicture", profilePicture)
        .then(async () => {
          this.getStatus(true);
        })
        .catch(async (err) => {
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", this.$t(err.response.data), "bottom", "right");
            this.pictureKey++;
          }
          await this.getStatus(true);
        });
    },
    async changeRoute(route) {
      if (route != this.$route.name) this.$router.push(route);
    },
    async AbsenceDialogOpen() {
      this.ShowAbsenceDialog = true;
    }
  }
};
</script>

<style scoped>
.cobi-rt-dn >>> .v-list-group__header__append-icon .v-icon {
  transform: rotate(0deg) !important;
  transition: transform 0.15s ease;
}
.cobi-rt-dn.v-list-group--active >>> .v-list-group__header__append-icon .v-icon {
  transform: rotate(90deg) !important;
}
</style>
